export const SITE = {
  name: "Trusted Leap",
  tagline: "Exceptional expertise. Without the traditional overhead.",
  description:
    "Trusted Leap is a curated B2B professional services marketplace connecting businesses with vetted independent experts across auditing, consulting, advisory, tax and legal services.",
  // Configurable placeholders — replace with verified company details before publication.
  legalEntity: "[Registered legal entity name]",
  companyDetails: "[Registered office and company registration details]",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", dropdown: true },
  { label: "How It Works", to: "/how-it-works" },
  { label: "For Businesses", to: "/for-businesses" },
  { label: "For Experts", to: "/for-experts" },
  { label: "About Us", to: "/about" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Use", to: "/terms-of-use" },
  { label: "Professional Services Disclaimer", to: "/professional-services-disclaimer" },
  { label: "Cookie Preferences", to: "/cookie-policy" },
];
